import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { GoalKey } from '@/modules/goal/constants/GoalKey';

export class GoalType extends Enum {
  key!: GoalKey;
  value!: string;
  icon!: string;
  description!: string;

  static PROVIDE_MINOR_BENEFICIARIES: GoalType = {
    key: GoalKey.PROVIDE_MINOR_BENEFICIARIES,
    get value(): string {
      return Lang.t('estategoal.provide-minor-beneficiaries');
    },
    icon: 'baby-boy',
    get description(): string {
      return Lang.t('estategoal.provide-minor-beneficiaries-description');
    }
  };

  static COST_EFFECTIVE_SIMPLE_WILL: GoalType = {
    key: GoalKey.COST_EFFECTIVE_SIMPLE_WILL,
    get value(): string {
      return Lang.t('estategoal.cost-effective-simple-will');
    },
    icon: 'legal-certificate',
    get description(): string {
      return Lang.t('estategoal.cost-effective-simple-will-description');
    }
  };

  static HIGHLY_DETAILED_INSTRUCTIONS: GoalType = {
    key: GoalKey.HIGHLY_DETAILED_INSTRUCTIONS,
    get value(): string {
      return Lang.t('estategoal.highly-detailed-instructions');
    },
    icon: 'assignments',
    get description(): string {
      return Lang.t('estategoal.highly-detailed-instructions-description');
    }
  };

  static AVOID_FAMILY_CONFLICTS: GoalType = {
    key: GoalKey.AVOID_FAMILY_CONFLICTS,
    get value(): string {
      return Lang.t('estategoal.family-conflict');
    },
    icon: 'smiley-devastated-1',
    get description(): string {
      return Lang.t('estategoal.family-conflict-description');
    }
  };

  static PROTECT_BENEFICIARIES: GoalType = {
    key: GoalKey.PROTECT_BENEFICIARIES,
    get value(): string {
      return Lang.t('estategoal.trust-to-protect');
    },
    icon: 'shield-permission',
    get description(): string {
      return Lang.t('estategoal.trust-to-protect-description');
    }
  };

  static REDUCE_LIABILITIES: GoalType = {
    key: GoalKey.REDUCE_LIABILITIES,
    get value(): string {
      return Lang.t('estategoal.reduce-liabilities');
    },
    icon: 'cash-payment-bag',
    get description(): string {
      return Lang.t('estategoal.reduce-liabilities-description');
    }
  };

  static SUPPORT_CREATING_WILL: GoalType = {
    key: GoalKey.SUPPORT_CREATING_WILL,
    get value(): string {
      return Lang.t('estategoal.support-while-creating-will');
    },
    icon: 'hand-expended',
    get description(): string {
      return Lang.t('estategoal.support-while-creating-will-description');
    }
  };

  static MULTIDISCIPLINARY_EXPERTS: GoalType = {
    key: GoalKey.MULTIDISCIPLINARY_EXPERTS,
    get value(): string {
      return Lang.t('estategoal.multidisciplinary-experts');
    },
    icon: 'team-meeting',
    get description(): string {
      return Lang.t('estategoal.multidisciplinary-experts-description');
    }
  };

  static PROFESSIONAL_TO_SETTLE_ESTATE: GoalType = {
    key: GoalKey.PROFESSIONAL_TO_SETTLE_ESTATE,
    get value(): string {
      return Lang.t('estategoal.professional-to-settle');
    },
    icon: 'single-neutral-briefcase',
    get description(): string {
      return Lang.t('estategoal.professional-to-settle-description');
    }
  };
}
